module.exports = __webpack_public_path__ + "static/img/IMG_20150310_144012.d1d3bd70.jpg";